import { useTranslation } from "@/hooks/useTranslation";
import { getSuggestionCardAnimationStyle } from "@/lib/prompt-utils";
import { cn } from "@/lib/utils";
import { Plus } from "lucide-react";

type EmptyPinnedSlotProps = {
  index: number;
  isTransitioning: boolean;
  disabled: boolean;
  onClick: () => void;
};

export function EmptyPinnedSlot({
  index,
  isTransitioning,
  disabled,
  onClick,
}: EmptyPinnedSlotProps) {
  const { t } = useTranslation();
  const isDisabled = isTransitioning || disabled;

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={isDisabled}
      className={cn(
        "group relative flex items-center justify-between gap-2 rounded-xl",
        "border-2 border-dashed border-muted-foreground/30 bg-transparent p-3 text-left text-sm",
        "hover:border-primary/50 hover:bg-muted/30 active:bg-muted/50",
        "transition-colors duration-200",
        "focus:outline-none focus:ring-2 focus:ring-primary/50",
        isDisabled && "pointer-events-none opacity-50",
      )}
      style={getSuggestionCardAnimationStyle(index, isTransitioning)}
      aria-label={t("prompt.pinned.empty.aria")}
    >
      <div className="flex items-center gap-2 min-w-0 flex-1">
        <div className="shrink-0 rounded-full flex items-center justify-center w-9 h-9 bg-muted/50 group-hover:bg-muted transition-colors">
          <Plus className="w-5 h-5 text-muted-foreground group-hover:text-primary transition-colors" />
        </div>
        <span className="text-muted-foreground line-clamp-2 text-xs group-hover:text-foreground transition-colors">
          {t("prompt.pinned.empty.label")}
        </span>
      </div>
    </button>
  );
}
